module.exports = __webpack_public_path__ + "4fef2507545e9f3ec90e8ff39c6a8985.svg";